export const groups = {
    Engineers: 'Engineers',
    Managers: 'Managers',
    ExpansionManagers: 'Expansion Managers',
    Support: 'Support',
};
